import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import contactsReducer from "./slices/contactsSlice";
import incensesReducer from "./slices/incensesSlice";
import spicesReducer from "./slices/spicesSlice";
import ordersReducer from "./slices/ordersSlice";
import userReducer from "./slices/userSlice";
import loaderReducer from "./slices/loaderSlice";
import rootSaga from "./sagas/rootSaga";

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    loader: loaderReducer,
    contacts: contactsReducer,
    incenses: incensesReducer,
    spices: spicesReducer,
    orders: ordersReducer,
    user: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

// Run the root saga
sagaMiddleware.run(rootSaga);

export default store;
